const config = {
  // API_URL: "http://192.168.1.2:4231/api/v1",
  // IMAGES_URL: "http://192.168.1.2:4231",
  API_URL: "https://app.adventuredating.com/backend/api/v1",
  IMAGES_URL: "https://app.adventuredating.com/backend",
};

export default config;
